import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface ValidateKimUploadParams {
  matterId: string;
  uploadId: string;
  fileId: string;
  extension: string;
}

export interface ValidateKimUploadResult {
  encrypted: boolean;
  detail?: string;
}

export const useValidateKimUpload = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useMutation<ValidateKimUploadResult, Error, ValidateKimUploadParams>(
    async ({ matterId, uploadId, fileId, extension }) => {
      const params = new URLSearchParams({ matterId, uploadId, fileId, extension });
      const res = await fetch(`${APIBaseChronos}/api/storage/kim/validate-upload?${params}`, fetchConfigGET);
      if (!res.ok) throw new Error('Failed to validate Kim upload');
      return res.json();
    },
  );
};
